<h3 mat-dialog-title>{{ 'dialog.add_organization_customer_symbol.title' | translate: {organization: data.organizationUnitName} }}</h3>
<mat-dialog-content>
  <form [formGroup]="newSymbolForm">
    <div class="flex-col gap-5">
      <app-asset-upload class="image" identifier="symbol-image" purpose="symbol" (uploaded)="addSymbolImage($event)">
        <ng-template let-uploadData="uploadData">
          <div class="image-container">
            <app-doenkids-image class="image" [maxWidth]="100" [maxHeight]="100" [mediaItem]="newSymbolForm.get('media_uuid').value"></app-doenkids-image>
          </div>
          <app-select-media identifier="symbol-image" [uploadData]="uploadData" purpose="symbol" (selected)="addSymbolImage($event)"></app-select-media>
        </ng-template>
      </app-asset-upload>
      <div class="flex-col gap-5 justify-around items-start">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'customer_symbol.name.label' | translate }}</mat-label>
          <input formControlName="name" matInput>
          @if (newSymbolForm.get('name')?.invalid) {
            <mat-error>
              {{ 'generic.form.required_field' | translate }}
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'customer_symbol.activity_type.label' | translate }}</mat-label>
          <mat-select formControlName="activity_type_id">
            <mat-option [value]="null">
              {{ 'dialog.add_organization_customer_symbol.all_types' | translate }}
            </mat-option>
            @for (type of (activityTypes$ | async); track type) {
              <mat-option [value]="type.id">
                {{ type.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions class="flex-row justify-end items-center">
  <button (click)="createNewSymbol()" [disabled]="!newSymbolForm.valid" mat-button>{{ 'generic.save' | translate }}</button>
</mat-dialog-actions>
